import { isUserVip } from "../vip/isUserVip";

export const idsMatch = (a, b) =>
  a != null && b != null && String(a) === String(b);

export const getReactionUserId = (reaction) =>
  reaction?.userId || reaction?.user?._id || reaction?._id || null;

export const isReactionVip = (reaction) =>
  isUserVip(reaction) || isUserVip(reaction?.user);

export const getMyReactionEmoji = (reactions = [], userId) => {
  if (!userId) return null;
  const mine = reactions.find((reaction) =>
    idsMatch(getReactionUserId(reaction), userId)
  );
  return mine?.emoji || null;
};

export const groupReactions = (reactions = []) => {
  const groups = [];
  const byEmoji = new Map();

  reactions.forEach((reaction) => {
    const emoji = reaction?.emoji;
    if (!emoji) return;

    if (!byEmoji.has(emoji)) {
      const group = {
        emoji,
        count: 0,
        users: [],
        hasVip: false,
      };
      byEmoji.set(emoji, group);
      groups.push(group);
    }

    const group = byEmoji.get(emoji);
    group.count += 1;
    group.users.push(reaction);
    if (isReactionVip(reaction)) group.hasVip = true;
  });

  return groups;
};

export const toggleReactionLocally = (reactions = [], user, emoji) => {
  const userId = user?._id || user?.id;
  if (!userId || !emoji) return reactions;

  const withoutMine = reactions.filter(
    (reaction) => !idsMatch(getReactionUserId(reaction), userId)
  );
  const mine = reactions.find((reaction) =>
    idsMatch(getReactionUserId(reaction), userId)
  );

  if (mine?.emoji === emoji) return withoutMine;

  return [
    ...withoutMine,
    {
      userId,
      userReference: "User",
      userName: user?.userName || user?.name || "",
      avatarUrl: user?.avatarUrl || user?.profile_pic || "",
      isVip: isUserVip(user),
      emoji,
      reactedAt: new Date().toISOString(),
    },
  ];
};

export const patchMessageReactions = (messages = [], messageId, reactions) => {
  if (!messageId) return messages;
  return messages.map((msg) =>
    idsMatch(msg?._id, messageId) ? { ...msg, reactions } : msg
  );
};

export const parseSocketErrorMessage = (err) => {
  if (!err) return "";
  if (typeof err === "string") return err;
  return (
    err.message ||
    err.msg ||
    err.error ||
    err.data?.message ||
    ""
  );
};
